import React, { useEffect } from 'react'
import NavbarContainer from '../components/Navbar/Navbar'
import { Col, Container, Row } from 'react-bootstrap'
import AboutusContainer from '../components/AboutusContainer/AboutusContainer'
import Footer from '../components/Footer/Footer'
import { useLocation } from "react-router-dom";
import { useSelector } from 'react-redux'

function Aboutus() {
  const { pathname } = useLocation();
  const layout = useSelector((state) => state.layoutRducer.layoutArray);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);


  return (
    <div style={{
      display:"flex",
          flexDirection: "column",
    justifyContent: "space-between",
    height:" 100vh",
    }}>
            <NavbarContainer />
      <Container>
        <Row>

          <Col md={12}>
            <AboutusContainer layout={layout} />

          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  )
}

export default Aboutus